module.exports = __webpack_public_path__ + "pf.svg?3ac8d5bdfe5d78013f568a73dd5b4d61";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/pf.svg
// module id = 1559
// module chunks = 0